import { render, staticRenderFns } from "./AppNotifications.vue?vue&type=template&id=74fb95c0&scoped=true&"
import script from "./AppNotifications.vue?vue&type=script&lang=js&"
export * from "./AppNotifications.vue?vue&type=script&lang=js&"
import style0 from "./AppNotifications.vue?vue&type=style&index=0&id=74fb95c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fb95c0",
  null
  
)

export default component.exports